import { operationsClient } from 'packages/lib/api/annotations-ops/http-client';
import {
  TaskHistoryEventPost,
  TaskHistoryEventSchema,
} from 'packages/lib/api/annotations-ops/contract';
import { PickupTaskResponseSchema } from 'packages/lib/api/annotations-ops/contract/pickup-task-response';

export const taskManApi = {
  history: {
    get: (userEmail: string, taskToken?: string) => {
      return operationsClient.get(
        `/task-management/history?userEmail=${userEmail}${
          taskToken ? `&taskToken=${taskToken}` : ''
        }`,
        {
          schema: TaskHistoryEventSchema.array(),
        }
      );
    },
    post: (body: TaskHistoryEventPost) => {
      return operationsClient.post('/task-management/history', {
        body,
      });
    },
  },
  queue: {
    pickup: (
      objectToken: string,
      taskGroupToken: string,
      userEmail: string
    ) => {
      return operationsClient.post(
        `/task-management/queue/pickup-by-object-token/${objectToken}?task_group_token=${taskGroupToken}&user_email=${userEmail}`,
        {
          schema: PickupTaskResponseSchema,
        }
      );
    },
  },
};
